import React, { Component } from 'react';
import {
  Container,
  Header,
  Segment,
  Button,
  Icon,
  Card,
  Grid,
  Image,
} from 'semantic-ui-react';
import ReactMarkdown from 'react-markdown';
import scrollToElement from 'scroll-to-element';

class Introduction extends Component {
  render() {
    const {
      tittel,
      ingress,
      introduksjonstekst,
      dokumentTittel,
      dokumentBeskrivelse,
      dokumentBilde,
      dokumentUrl,
      skOmMedlemsskap,
      kampanjetittel,
      kampanjeundertittel,
      sertifiserteTittel,
      sertifiserteBedrifter,
      knappOversiktOverSertifiserteBedrifter,
    } = this.props;

    console.log(this.props);

    const { members } = sertifiserteBedrifter;

    return (
      <Container text>
        <Header as="h1">{tittel}</Header>

        <Segment basic size="huge" className="no-padding">
          {ingress}
        </Segment>

        <ReactMarkdown source={introduksjonstekst} />

        <Segment basic textAlign="center">
          <Card
            href={dokumentUrl}
            centered
            className="criterion-norsk-okoturisme"
          >
            <Card.Content>
              <Card.Header>{dokumentTittel}</Card.Header>
              <Card.Meta>pdf-fil</Card.Meta>
              <Card.Description>{dokumentBeskrivelse}</Card.Description>
            </Card.Content>
            <Image src={dokumentBilde} />
          </Card>
        </Segment>

        <Segment basic textAlign="center">
          <Button
            color="green"
            className="hero-button"
            size="huge"
            target="_blank"
            onClick={this.onClickProsess}
          >
            {skOmMedlemsskap} <Icon name="angle right" />
          </Button>
        </Segment>

        <Segment basic compact className="kampanje-wrapper">
          <Segment circular inverted compact>
            <Header as="h2" inverted>
              {kampanjetittel}
              <Header.Subheader>{kampanjeundertittel}</Header.Subheader>
            </Header>
          </Segment>
        </Segment>

        <Segment raised padded="very" textAlign="center">
          <Header as="h2" textAlign="center">
            {sertifiserteTittel}
          </Header>
          <Grid centered columns={6} className="members" doubling>
            {members.map(member => (
              <Grid.Column verticalAlign="middle" stretched key={member[0]}>
                <Image
                  src={`https://res.cloudinary.com/hanen/image/upload/c_limit,h_256,w_256/${
                    member[0]
                  }`}
                  href={member[1]}
                />
              </Grid.Column>
            ))}
          </Grid>

          <Segment basic textAlign="center">
            <Button
              as="a"
              target="_blank"
              secondary
              href="http://www.hanen.no/utforsk/118"
            >
              {knappOversiktOverSertifiserteBedrifter}{' '}
              <Icon name="angle right" />
            </Button>
          </Segment>
        </Segment>
      </Container>
    );
  }

  onClickProsess() {
    scrollToElement('#om');
  }
}

export default Introduction;



// WEBPACK FOOTER //
// ./src/LandingPage/Introduction.js